(() => {
  const MSG_ALREADY_JOINED = "Bereits teilgenommen";
  const MSG_IP_LIMIT = "Teilnahmelimit erreicht";
  const MSG_NO_ACT = "Diese Kampagne ist nicht verfügbar.";
  const MSG_NO_LOGIN = "Bitte gib eine gültige E-Mail-Adresse ein.";
  const MSG_SERVER_ERROR = "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  const PREVIEW_LUCKY_CODE = "SHOKZ15&INSTA15";
  const COPY_BUBBLE_MS = 2000;
  const DEFAULT_KLAVIYO_FORM_ID = "RpDQFd";
  const MOBILE_MQ = "(max-width: 1100px)";

  const track = (eventName, parameters) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: eventName,
      event_parameters: parameters
    });
  };

  const observeOnce = (element, onVisible, threshold = 0.3) => {
    if (!element || element.dataset.si26Impressed === "true") return;
    const fire = () => {
      if (element.dataset.si26Impressed === "true") return;
      element.dataset.si26Impressed = "true";
      onVisible();
    };
    if (typeof IntersectionObserver === "undefined") {
      fire();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          fire();
          observer.disconnect();
        });
      },
      { threshold }
    );
    observer.observe(element);
  };

  const TILE_COUNT = 4;
  const SPIN_LAPS = 3;
  const MASK_FADE_MS = 160;
  const FAST_STEP_MS = 320;
  const SLOW_STEP_MS = [380, 460, 560, 700, 920];
  const LAND_HOLD_MS = 420;
  const RANK_TO_SLOT = {
    first: 0,
    second: 2,
    lucky: 3
  };
  const SLOT_TO_RANK = {
    0: "first",
    1: "lucky",
    2: "second",
    3: "lucky"
  };
  const VALID_RANKS = ["first", "second", "lucky"];

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const mobileMq = window.matchMedia(MOBILE_MQ);
  const instances = new Set();

  const wait = (duration) =>
    new Promise((resolve) => {
      window.setTimeout(resolve, duration);
    });

  const nextFrame = () =>
    new Promise((resolve) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(resolve);
      });
    });

  const isMobile = () => mobileMq.matches;

  const pickRandomInt = (max) => Math.floor(Math.random() * max);

  const pickField = (source, ...keys) => {
    if (!source || typeof source !== "object") return undefined;
    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
        return source[key];
      }
    }
    return undefined;
  };

  const splitCoupon = (raw) => {
    const value = String(raw || "").trim();
    if (!value) return { shokz: "", insta: "" };
    const separator = value.indexOf("&");
    if (separator < 0) {
      console.warn('[si26-lottery] coupon missing "&"; showing full code in both slots', value);
      return { shokz: value, insta: value };
    }
    return {
      shokz: value.slice(0, separator).trim(),
      insta: value.slice(separator + 1).trim()
    };
  };

  const getErrorMessage = (actStatus) => {
    switch (actStatus) {
      case "no_finish":
        return MSG_ALREADY_JOINED;
      case "no_finish_ip":
        return MSG_IP_LIMIT;
      case "no_act":
        return MSG_NO_ACT;
      case "no_login":
        return MSG_NO_LOGIN;
      case "sign_invalid":
        return MSG_SERVER_ERROR;
      default:
        return MSG_SERVER_ERROR;
    }
  };

  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === "function" && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
  };

  const observeInview = (root) => {
    if (!root || root.classList.contains("si26-is-inview")) return;

    if (reduceMotion.matches || typeof IntersectionObserver === "undefined") {
      root.classList.add("si26-is-inview");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("si26-is-inview");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(root);
  };

  const initLottery = (root) => {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    observeInview(root);

    if (root.dataset.campaignPhase === "winners" || root.querySelector("[data-si26-winners]")) {
      return;
    }

    const formPhase = root.querySelector("[data-si26-form-phase]");
    const formShell = root.querySelector("[data-si26-lottery-form]");
    const subscribed = root.querySelector("[data-si26-subscribed]");
    const enterButton = root.querySelector("[data-si26-enter]");
    const tiles = [...root.querySelectorAll("[data-si26-tile]")];
    const go = root.querySelector("[data-si26-go]");
    const pool = root.querySelector("[data-si26-pool]");
    const spinMask = root.querySelector("[data-si26-spin-mask]");
    const spinMaskImg = root.querySelector("[data-si26-spin-mask-img]");
    const error = root.querySelector("[data-si26-error]");
    const previewButton = root.querySelector("[data-si26-preview-draw]");
    const dialog = root.querySelector("[data-si26-result-dialog]");
    const dialogClose = root.querySelector("[data-si26-modal-close]");
    const sheetClose = root.querySelector("[data-si26-sheet-close]");
    const sheetDismiss = root.querySelector("[data-si26-sheet-dismiss]");
    const klaviyoFormId = (root.dataset.klaviyoFormId || DEFAULT_KLAVIYO_FORM_ID).trim();

    if (spinMask && spinMaskImg) {
      const markMaskReady = () => {
        if (spinMaskImg.naturalWidth <= 0) return;
        const src = spinMaskImg.currentSrc || spinMaskImg.src;
        if (!src) return;
        spinMask.style.setProperty("--si26-mask-url", `url("${src}")`);
        spinMask.classList.add("is-masked");
      };
      const fallbackColorMask = () => {
        spinMask.classList.remove("is-masked");
        spinMask.style.removeProperty("--si26-mask-url");
      };
      if (spinMaskImg.complete) {
        if (spinMaskImg.naturalWidth > 0) markMaskReady();
        else fallbackColorMask();
      } else {
        spinMaskImg.addEventListener("load", markMaskReady, { once: true });
        spinMaskImg.addEventListener("error", fallbackColorMask, { once: true });
      }
    }

    if (!tiles.length) return;

    const apiEnabled = root.dataset.lotteryApiEnabled === "true";
    const tokenUrl = root.dataset.lotteryTokenUrl || "https://global.shokz.com/lottery/start";
    const apiUrl = root.dataset.lotteryApiUrl || "https://global.shokz.com/lottery/openapi_v3";
    const actId = (root.dataset.lotteryActId || "").trim();
    const sign = (root.dataset.lotterySign || "").trim();
    const usageScenarios = root.dataset.usageScenarios || "cs";
    const isDesignMode = Boolean(window.Shopify?.designMode);
    const storageScope = actId || root.dataset.sectionId || "si26";
    const sessionKey = `si26-lottery:${storageScope}:session`;

    let isDrawing = false;
    let hasDrawn = false;
    let klaviyoSubscribed = false;
    let cachedEmail = "";
    let copyBubbleTimer = null;

    const storageKeyFor = (email) => `si26-lottery:${storageScope}:${email.trim().toLowerCase()}`;

    const readJson = (store, key) => {
      try {
        const raw = store.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (err) {
        return null;
      }
    };

    const writeJson = (store, key, value) => {
      try {
        store.setItem(key, JSON.stringify(value));
      } catch (err) {
        /* private mode / quota */
      }
    };

    const persistResult = (email, record) => {
      if (!email) return;
      writeJson(window.localStorage, storageKeyFor(email), record);
      writeJson(window.sessionStorage, sessionKey, { ...record, email });
    };

    let lastResult = null;

    const rememberResult = (record) => {
      if (!record?.key) return;
      lastResult = {
        key: resolveResultKey(record.key),
        slot: record.slot,
        code: (record.code || "").trim(),
        priceId: record.priceId || ""
      };
    };

    const readStoredResult = (email) => {
      if (!email) return null;
      return readJson(window.localStorage, storageKeyFor(email));
    };

    const resolveResultKey = (resultKey) => {
      if (VALID_RANKS.includes(resultKey)) return resultKey;
      const fallback = root.dataset.previewResult;
      if (VALID_RANKS.includes(fallback)) return fallback;
      return "first";
    };

    const pickPreviewTarget = () => {
      const preview = (root.dataset.previewResult || "random").trim();
      if (preview === "random" || !VALID_RANKS.includes(preview)) {
        const slot = pickRandomInt(TILE_COUNT);
        const key = SLOT_TO_RANK[slot];
        // Both lucky cells share one prize — always settle on the top tile.
        return { key, slot: key === "lucky" ? RANK_TO_SLOT.lucky : slot };
      }
      if (preview === "lucky") {
        return { key: "lucky", slot: RANK_TO_SLOT.lucky };
      }
      return { key: preview, slot: RANK_TO_SLOT[preview] ?? 0 };
    };

    const normalizeSlot = (slot) => {
      const n = Number(slot);
      if (!Number.isFinite(n)) return null;
      const index = Math.trunc(n);
      if (index < 0 || index >= TILE_COUNT) return null;
      return index;
    };

    const slotForRank = (rank, preferredSlot) => {
      const key = resolveResultKey(rank);
      // Lucky always uses the top cell so spin land + win state stay aligned.
      if (key === "lucky") return RANK_TO_SLOT.lucky;
      const slot = normalizeSlot(preferredSlot);
      if (slot !== null && SLOT_TO_RANK[slot] === key) return slot;
      return RANK_TO_SLOT[key] ?? 0;
    };

    const pickSpinSlot = (rank, preferredSlot) => slotForRank(rank, preferredSlot);

    const tileForRank = (rank) => tiles.find((tile) => tile.dataset.si26Rank === rank) || null;

    const setMaskSlot = (slot, { faded = false } = {}) => {
      if (!spinMask) return;
      spinMask.hidden = false;
      spinMask.classList.toggle("is-fading", faded);
      spinMask.classList.remove("is-off");
      spinMask.dataset.slot = String(slot);
    };

    const hideMask = async ({ animate = false } = {}) => {
      if (!spinMask) return;
      if (animate && !spinMask.hidden) {
        spinMask.classList.add("is-fading");
        await wait(MASK_FADE_MS);
      }
      spinMask.classList.add("is-fading");
      spinMask.hidden = true;
      spinMask.removeAttribute("data-slot");
    };

    const setActiveSlot = (slot) => {
      tiles.forEach((tile) => {
        tile.classList.toggle("is-active", Number(tile.dataset.si26Slot) === slot);
        tile.classList.remove("is-landed");
      });
    };

    const setLandedSlot = (slot) => {
      tiles.forEach((tile) => {
        const landed = Number(tile.dataset.si26Slot) === slot;
        tile.classList.toggle("is-active", landed);
        tile.classList.toggle("is-landed", landed);
      });
    };

    const clearTileHighlights = () => {
      tiles.forEach((tile) => {
        tile.classList.remove("is-active", "is-landed");
      });
      hideMask();
    };

    const pulseMaskAt = async (slot, stepBudget) => {
      const fade = Math.min(MASK_FADE_MS, Math.max(80, Math.floor(stepBudget / 2.4)));
      const hold = Math.max(0, stepBudget - fade * 2);

      setActiveSlot(slot);
      setMaskSlot(slot, { faded: true });
      await nextFrame();
      setMaskSlot(slot, { faded: false });
      await wait(fade);
      if (hold) await wait(hold);
      if (spinMask) spinMask.classList.add("is-fading");
      await wait(fade);
    };

    const stopGoLoop = () => {
      root.classList.add("is-spinning");
      go?.classList.add("is-stopped");
    };

    const resumeGoLoop = () => {
      if (hasDrawn) return;
      root.classList.remove("is-spinning");
      go?.classList.remove("is-stopped");
    };

    const setSubmitLocked = (locked) => {
      root.classList.toggle("is-submitting", locked);
      const klaviyoButton = formShell?.querySelector("button");
      if (klaviyoButton) {
        klaviyoButton.disabled = locked || hasDrawn;
        klaviyoButton.setAttribute("aria-busy", locked ? "true" : "false");
      }
      if (previewButton) {
        previewButton.disabled = locked || hasDrawn;
        previewButton.setAttribute("aria-busy", locked ? "true" : "false");
      }
    };

    const shakeForm = () => {
      if (!formShell) return;
      formShell.classList.remove("is-shaking");
      window.requestAnimationFrame(() => {
        formShell.classList.add("is-shaking");
      });
      window.setTimeout(() => {
        formShell.classList.remove("is-shaking");
      }, 380);
    };

    const openSheet = () => {
      if (!isMobile() || hasDrawn) return;
      if (formPhase) formPhase.hidden = false;
      root.classList.add("is-sheet-open");
      document.body.classList.add("si26-lottery-sheet-open");
    };

    const closeSheet = () => {
      root.classList.remove("is-sheet-open");
      document.body.classList.remove("si26-lottery-sheet-open");
    };

    const promptSubscribe = () => {
      if (hasDrawn || isDrawing) return;
      if (isMobile()) openSheet();
      shakeForm();
    };

    const showError = (message) => {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
      if (isMobile()) openSheet();
      shakeForm();
    };

    const hideError = () => {
      if (!error) return;
      error.hidden = true;
      error.textContent = "";
    };

    const hideCopyBubble = () => {
      if (copyBubbleTimer) {
        window.clearTimeout(copyBubbleTimer);
        copyBubbleTimer = null;
      }
      dialog?.querySelectorAll("[data-si26-copied]").forEach((bubble) => {
        bubble.hidden = true;
      });
    };

    const showCopyBubble = (button) => {
      const wrap = button?.closest(".si26-lottery-modal__code-row");
      const bubble = wrap?.querySelector("[data-si26-copied]");
      if (!bubble) return;
      hideCopyBubble();
      bubble.hidden = false;
      copyBubbleTimer = window.setTimeout(hideCopyBubble, COPY_BUBBLE_MS);
    };

    const copyText = async (value, button) => {
      const code = (value || "").trim();
      if (!code) return;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const input = document.createElement("textarea");
          input.value = code;
          input.setAttribute("readonly", "");
          input.style.position = "absolute";
          input.style.left = "-9999px";
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        showCopyBubble(button);
      } catch (err) {
        console.error("[si26-lottery] copy error", err);
      }
    };

    const mapPriceId = (priceId, actPriceId) => {
      const ids = [priceId, actPriceId]
        .filter((value) => value !== undefined && value !== null && value !== "")
        .map((value) => String(value));
      if (!ids.length) return null;
      const ranks = [
        ["first", root.dataset.priceIdFirst, root.dataset.actPriceIdFirst],
        ["second", root.dataset.priceIdSecond, root.dataset.actPriceIdSecond],
        ["lucky", root.dataset.priceIdLucky, root.dataset.actPriceIdLucky]
      ];
      for (const [rank, price, actPrice] of ranks) {
        const known = [price, actPrice].map((value) => (value || "").trim()).filter(Boolean);
        if (ids.some((id) => known.includes(id))) return rank;
      }
      return null;
    };

    const getStepDelays = (totalHighlights) => {
      const delays = [];
      const slowCount = Math.min(SLOW_STEP_MS.length, totalHighlights);
      const fastCount = Math.max(0, totalHighlights - slowCount);
      for (let i = 0; i < fastCount; i += 1) delays.push(FAST_STEP_MS);
      for (let i = 0; i < slowCount; i += 1) delays.push(SLOW_STEP_MS[i]);
      return delays;
    };

    const spinPuzzle = async (resultKey, preferredSlot) => {
      const key = resolveResultKey(resultKey);
      const targetSlot = pickSpinSlot(key, preferredSlot);
      stopGoLoop();

      if (reduceMotion.matches) {
        setActiveSlot(targetSlot);
        setMaskSlot(targetSlot, { faded: false });
        setLandedSlot(targetSlot);
        await hideMask({ animate: true });
        return { key, slot: targetSlot };
      }

      // Clockwise from first (slot 0): 0 → 1 → 2 → 3 → …
      const totalMoves = SPIN_LAPS * TILE_COUNT + targetSlot;
      const totalHighlights = totalMoves + 1;
      const delays = getStepDelays(totalHighlights);

      for (let i = 0; i < totalHighlights; i += 1) {
        await pulseMaskAt(i % TILE_COUNT, delays[i] || FAST_STEP_MS);
      }

      setActiveSlot(targetSlot);
      setMaskSlot(targetSlot, { faded: true });
      await nextFrame();
      setMaskSlot(targetSlot, { faded: false });
      await wait(MASK_FADE_MS);
      setLandedSlot(targetSlot);
      await wait(LAND_HOLD_MS);
      await hideMask({ animate: true });
      return { key, slot: targetSlot };
    };

    const fillModal = (key, meta = {}) => {
      if (!dialog) return;
      const tile = tileForRank(key);
      const isLucky = key === "lucky";
      const media = dialog.querySelector("[data-si26-modal-media]");
      const image = dialog.querySelector("[data-si26-modal-image]");
      const eyebrow = dialog.querySelector("[data-si26-modal-eyebrow]");
      const lead = dialog.querySelector("[data-si26-modal-lead]");
      const title = dialog.querySelector("[data-si26-modal-title]");
      const description = dialog.querySelector("[data-si26-modal-description]");
      const prizeCopy = dialog.querySelector("[data-si26-modal-prize]");
      const luckyCopy = dialog.querySelector("[data-si26-modal-lucky]");
      const codes = splitCoupon(meta.code || "");
      const shokzEl = dialog.querySelector("[data-si26-code-shokz]");
      const instaEl = dialog.querySelector("[data-si26-code-insta]");

      dialog.dataset.resultKey = key;
      dialog.classList.toggle("is-lucky", isLucky);
      dialog.classList.toggle("is-prize", !isLucky);
      if (eyebrow) eyebrow.textContent = tile?.dataset.resultEyebrow || "Herzlichen Glückwunsch!";
      if (lead) {
        const leadText = (tile?.dataset.resultLead || lead.textContent || "Du hast gewonnen").trim() || "Du hast gewonnen";
        lead.textContent = leadText;
        lead.hidden = false;
      }
      if (title) title.textContent = tile?.dataset.resultTitle || "";
      if (description) {
        const desc = (tile?.dataset.resultDescription || "").trim();
        description.textContent = desc;
        description.hidden = !desc || isLucky;
      }

      if (image) {
        const src = tile?.dataset.modalImage || "";
        if (src) {
          image.src = src;
          image.alt = tile?.dataset.resultTitle || "";
          image.hidden = false;
        } else {
          image.removeAttribute("src");
          image.hidden = true;
        }
      }
      if (media) media.hidden = true;

      if (prizeCopy) prizeCopy.hidden = isLucky;
      if (luckyCopy) luckyCopy.hidden = !isLucky;
      if (shokzEl) shokzEl.textContent = codes.shokz;
      if (instaEl) instaEl.textContent = codes.insta;
    };

    const showSubscribed = () => {
      closeSheet();
      if (formPhase) formPhase.hidden = true;
      if (enterButton) enterButton.hidden = true;
      if (subscribed) {
        subscribed.hidden = false;
        subscribed.classList.add("is-visible");
      }
      root.classList.add("is-drawn", "is-subscribed");
      root.classList.remove("is-spinning", "is-sheet-open");
      go?.classList.add("is-stopped");
      setSubmitLocked(true);
    };

    const showResultModal = (resultKey, meta = {}) => {
      const key = resolveResultKey(resultKey);
      fillModal(key, meta);
      hideCopyBubble();
      setLandedSlot(slotForRank(key, meta.slot));
      root.classList.add("is-drawn");
      root.classList.remove("is-spinning");
      go?.classList.add("is-stopped");
      openDialog(dialog);
    };

    const restoreResult = (record, { showModal = false } = {}) => {
      if (!record?.key) return false;
      const key = resolveResultKey(record.key);
      rememberResult(record);
      hasDrawn = true;
      isDrawing = false;
      klaviyoSubscribed = true;
      setSubmitLocked(true);
      stopGoLoop();
      if (showModal) {
        showResultModal(key, record);
      } else {
        setLandedSlot(slotForRank(key, record.slot));
        showSubscribed();
      }
      return true;
    };

    const postJson = (url, body) =>
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      }).then(async (res) => {
        let payload = null;
        try {
          payload = await res.json();
        } catch (parseError) {
          payload = null;
        }
        if (!res.ok) {
          const requestError = new Error(`HTTP error ${res.status}`);
          requestError.payload = payload;
          throw requestError;
        }
        return payload;
      });

    const requestLottery = async (mbId) => {
      const activityId = Number(actId) || actId;
      const tokenPayload = await postJson(tokenUrl, {
        actId: activityId,
        sign
      });
      const tokenCode = tokenPayload?.code;
      const token = pickField(tokenPayload?.data, "token");
      if ((tokenCode !== 200 && tokenCode !== "200") || !token) {
        const tokenError = new Error("lottery token failed");
        tokenError.payload = tokenPayload;
        throw tokenError;
      }

      return postJson(apiUrl, {
        mbId,
        actId: activityId,
        usageScenarios,
        sign,
        token
      });
    };

    const parseLotteryResponse = (payload) => {
      const data = payload?.data || {};
      const outerCode = payload?.code;
      const status = pickField(data, "status");
      const actStatus = pickField(data, "act_status", "actStatus");
      const priceId = pickField(data, "priceId", "price_id");
      const actPriceId = pickField(data, "actPriceId", "act_price_id");
      const code = pickField(data, "code");
      const priceName = pickField(data, "priceName", "price_name");
      const rank = mapPriceId(priceId, actPriceId);

      const isSuccess =
        (outerCode === 200 || outerCode === "200") &&
        Boolean(rank) &&
        (status === "ok" || ((priceId !== undefined || actPriceId !== undefined) && !actStatus));

      if (isSuccess) {
        return {
          ok: true,
          key: rank,
          priceId,
          code: code || "",
          priceName: priceName || ""
        };
      }

      return {
        ok: false,
        actStatus: actStatus || status || "error"
      };
    };

    const completeDraw = async (resultKey, meta = {}, emailValue = "", preferredSlot) => {
      const spun = await spinPuzzle(resultKey, preferredSlot);
      const record = {
        key: spun.key,
        slot: spun.slot,
        code: (meta.code || "").trim(),
        priceId: meta.priceId || ""
      };
      hasDrawn = true;
      isDrawing = false;
      setSubmitLocked(true);
      rememberResult(record);
      persistResult(emailValue || cachedEmail, record);
      showResultModal(spun.key, record);
    };

    const failDraw = (message = MSG_SERVER_ERROR) => {
      isDrawing = false;
      setSubmitLocked(false);
      resumeGoLoop();
      clearTileHighlights();
      showError(message);
    };

    const startDraw = (emailFromEvent, options = {}) => {
      const allowPreviewWithoutKlaviyo = Boolean(options.preview) && isDesignMode && !apiEnabled;
      const emailValue = (emailFromEvent || cachedEmail || "").trim();

      if (options.fromKlaviyo && emailValue) {
        klaviyoSubscribed = true;
      }

      if (isDrawing || hasDrawn) return;

      if (!allowPreviewWithoutKlaviyo) {
        if (!emailValue) {
          promptSubscribe();
          return;
        }
        if (!klaviyoSubscribed && !options.fromKlaviyo) {
          promptSubscribe();
          return;
        }
      }

      closeSheet();

      if (!(isDesignMode && !apiEnabled)) {
        const stored = emailValue ? readStoredResult(emailValue) : null;
        if (stored?.key) {
          hideError();
          cachedEmail = emailValue;
          restoreResult(stored, { showModal: false });
          return;
        }
      } else {
        hasDrawn = false;
        root.classList.remove("is-drawn", "is-subscribed");
        if (formPhase) formPhase.hidden = false;
        if (enterButton) enterButton.hidden = false;
        if (subscribed) {
          subscribed.hidden = true;
          subscribed.classList.remove("is-visible");
        }
        closeDialog(dialog);
      }

      if (hasDrawn) return;

      cachedEmail = emailValue || "preview@theme-editor";
      hideError();
      isDrawing = true;
      setSubmitLocked(true);

      if (!apiEnabled) {
        const preview = pickPreviewTarget();
        const previewMeta = {
          code: preview.key === "lucky" ? PREVIEW_LUCKY_CODE : ""
        };
        completeDraw(preview.key, previewMeta, cachedEmail, preview.slot).catch((err) => {
          console.error("[si26-lottery]", err);
          failDraw(MSG_SERVER_ERROR);
        });
        return;
      }

      requestLottery(emailValue)
        .then((payload) => {
          const parsed = parseLotteryResponse(payload);
          if (parsed.ok) {
            return completeDraw(parsed.key, parsed, emailValue);
          }

          if (parsed.actStatus === "no_finish") {
            const previous = readStoredResult(emailValue);
            if (previous?.key) {
              restoreResult(previous, { showModal: false });
              return;
            }
          }

          failDraw(getErrorMessage(parsed.actStatus));
        })
        .catch((err) => {
          const actStatus = pickField(err?.payload?.data, "act_status", "actStatus") || "";
          if (actStatus === "no_finish") {
            const previous = readStoredResult(emailValue);
            if (previous?.key) {
              restoreResult(previous, { showModal: false });
              return;
            }
          }
          if (actStatus) {
            failDraw(getErrorMessage(actStatus));
            return;
          }
          failDraw(MSG_SERVER_ERROR);
          console.error("[si26-lottery]", err);
        });
    };

    const api = {
      root,
      formId: klaviyoFormId,
      handleEmailSubmit: (emailValue) => startDraw(emailValue, { fromKlaviyo: true }),
      handleEmailFail: () => {
        klaviyoSubscribed = false;
      }
    };
    instances.add(api);
    root._si26LotteryApi = {
      ...api,
      startDraw: (emailValue) => startDraw(emailValue, { fromKlaviyo: true })
    };

    observeOnce(root, () => {
      track("module_impression", { module: "insta&shokz_sub" });
    });

    root.querySelectorAll(".si26-lottery__shop-card").forEach((link) => {
      link.addEventListener("click", () => {
        const buttonName = link.classList.contains("si26-lottery__shop-card--insta") ? "insta" : "shokz";
        const contentName = root.querySelector(".si26-lottery__subscribed-heading")?.textContent?.trim() || "";
        track("select_content", {
          content_type: "insta&shokz_jump",
          content_name: contentName,
          button_name: buttonName
        });
      });
    });

    const viewResult = root.querySelector("[data-si26-view-result]");
    viewResult?.addEventListener("click", () => {
      if (!lastResult?.key) {
        const sessionRecord = readJson(window.sessionStorage, sessionKey);
        if (sessionRecord?.key) rememberResult(sessionRecord);
      }
      if (!lastResult?.key) return;
      showResultModal(lastResult.key, lastResult);
    });

    dialog?.querySelectorAll("[data-si26-copy]").forEach((button) => {
      button.addEventListener("click", () => {
        const target = button.dataset.si26Copy;
        const codeEl = dialog.querySelector(`[data-si26-code-${target}]`);
        copyText(codeEl?.textContent || "", button);
      });
    });

    previewButton?.addEventListener("click", () => {
      startDraw("preview@theme-editor", { preview: true, fromKlaviyo: true });
    });

    go?.addEventListener("click", (event) => {
      event.preventDefault();
      if (hasDrawn || isDrawing) return;
      if (klaviyoSubscribed && cachedEmail) {
        startDraw(cachedEmail, { fromKlaviyo: true });
        return;
      }
      promptSubscribe();
    });

    enterButton?.addEventListener("click", (event) => {
      event.preventDefault();
      promptSubscribe();
    });

    pool?.addEventListener("click", (event) => {
      if (!isMobile() || hasDrawn || isDrawing) return;
      if (event.target.closest("[data-si26-go]")) return;
      if (klaviyoSubscribed && cachedEmail) return;
      promptSubscribe();
    });

    sheetClose?.addEventListener("click", closeSheet);
    sheetDismiss?.addEventListener("click", closeSheet);

    dialogClose?.addEventListener("click", () => {
      closeDialog(dialog);
      showSubscribed();
    });
    dialog?.addEventListener("click", (event) => {
      if (event.target === dialog) {
        closeDialog(dialog);
        showSubscribed();
      }
    });
    dialog?.addEventListener("close", () => {
      hideCopyBubble();
      if (hasDrawn) showSubscribed();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (root.classList.contains("is-sheet-open")) closeSheet();
    });

    if (!(isDesignMode && !apiEnabled)) {
      const sessionRecord = readJson(window.sessionStorage, sessionKey);
      if (sessionRecord?.key) {
        if (sessionRecord.email) cachedEmail = sessionRecord.email;
        restoreResult(sessionRecord, { showModal: false });
      }
    }
  };

  const init = (scope = document) => {
    if (scope.matches?.("[data-si26-lottery]")) {
      initLottery(scope);
    }
    scope.querySelectorAll?.("[data-si26-lottery]").forEach(initLottery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));

  if (!window.__si26KlaviyoFormsBound) {
    window.__si26KlaviyoFormsBound = true;
    window.addEventListener("klaviyoForms", (event) => {
      const detail = event.detail || {};
      const email = detail.metaData?.$email || "";
      const matched = [];

      instances.forEach((api) => {
        if (!api?.root || !document.contains(api.root)) {
          instances.delete(api);
          return;
        }
        if (!detail.formId || !api.formId || detail.formId !== api.formId) return;
        matched.push(api);
      });

      if (!matched.length) return;

      if (detail.type === "submit") {
        matched.forEach((api) => {
          track("subscribe", {
            module: "insta&shokz_sub",
            status: "success",
            email,
            content_name: ""
          });
          api.handleEmailSubmit(email);
        });
        return;
      }

      if (detail.type === "failedSubmit" || detail.type === "error") {
        matched.forEach((api) => {
          track("subscribe", {
            module: "insta&shokz_sub",
            status: "fail",
            email,
            content_name: ""
          });
          api.handleEmailFail(email);
        });
      }
    });
  }
})();
